import { getDescriptor } from "@addons/registry";
import { IChangePlanData, ICreatePurchaseAddOn } from "@stores/purchases/types";
import { ISubscription } from "@stores/subscriptions/types";
import { getAddonSubscribedProducts } from "@stores/subscriptions/utils";

/** an add-on without an estimate row never shows on the estimate */
export function removeHiddenAddOns<
  T extends Pick<ICreatePurchaseAddOn, "product_type">,
>(addOnsList: T[]): T[] {
  return addOnsList.filter(
    ({ product_type }) => !!getDescriptor(product_type)?.getEstimateRowItem,
  );
}

export function hasAddOnsChanges(
  subscription: ISubscription,
  changesData: IChangePlanData,
): boolean {
  const { subscribed_products } = subscription;
  const subscriptionAddOns = removeHiddenAddOns(
    getAddonSubscribedProducts(subscribed_products),
  )
    .map(({ product_type, prepaid_units }) => ({ product_type, prepaid_units }))
    .map(
      ({ product_type, prepaid_units }) => `${product_type}_${prepaid_units}`,
    )
    .sort();

  const { upsert_add_ons = [], remove_add_ons = [] } = changesData;
  const upsertAddOns = removeHiddenAddOns(upsert_add_ons)
    .map(({ product_type, prepaid_units }) => ({ product_type, prepaid_units }))
    .map(
      ({ product_type, prepaid_units }) => `${product_type}_${prepaid_units}`,
    )
    .sort();

  const hasSomeAddOnsChanges =
    upsertAddOns.filter((upsertAddOnStr) =>
      subscriptionAddOns.includes(upsertAddOnStr),
    ).length === 0;

  return remove_add_ons.length > 0 || hasSomeAddOnsChanges;
}
